import { Grid } from '@material-ui/core'
import { Filter, TextField, useFilter } from 'elentari'
import React from 'react'
import { Field } from 'react-final-form'
import { CustomMaskedField } from '../../components/CustomDisabledFields'

export const RiscoFilter = () => {
  const filter = useFilter({})

  return (
    <Filter {...filter} labels={{ find: 'Buscar', clear: 'Limpar' }}>
      <Grid container spacing={3}>
        <Grid item md={2} xs={12}>
          <Field
            fullWidth
            name="numero"
            label="Número"
            component={CustomMaskedField}
            mask={[/\d/, /\d/]}
          />
        </Grid>
        <Grid item md={10} xs={12}>
          <Field
            fullWidth
            name="descricao"
            label="Descrição"
            component={TextField}
          />
        </Grid>
      </Grid>
    </Filter>
  )
}
